import React from "react";
import { PanelEditSmmDomain } from "../../../UI/SmmDomain/Edit/PanelEditSmmDomain";

const EditSmmDomain = () => {
  return (
    <div>
      <PanelEditSmmDomain />
    </div>
  );
};

export default EditSmmDomain;
